import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pdfLink: '',
    price: 0,
    tva: 20,
    beautifulPrice: '',
    beautifulTva: '',
    beautifulPriceTTC: '',
    devis: [
      {id: 0, coloris: 'Abalone', finition: 'mat', group: 4, price: 0},
      {id: 1, longueur: null, largeur: null, epaisseur: 0, price: 0},
      {id: 2, longueur: 0, chant: 0, price: 0},
      {id: 3, longueur: 0, largeur: 0, epaisseur: 0, price: 0},
      {id: 4,
        options: [
          {id: 0, quantity: 0, price: 0},
          {id: 1, quantity: 0, price: 0},
          {id: 2, quantity: 0, price: 0},
          {id: 3, quantity: 0, price: 0},
          {id: 4, quantity: 0, price: 0},
          {id: 5, quantity: 0, price: 0},
          {id: 6, quantity: 0, price: 0},
          {id: 7, quantity: 0, price: 0}
        ]
      },
      {id: 5,
        services: [
          {id: 0, selected: 0, price: 0},
          {id: 1, selected: 0, price: 0},
          {id: 2, selected: 0, price: 0},
          {id: 3, selected: 0, price: 0},
          {id: 4, selected: 0, price: 0},
          {id: 5, selected: 0, price: 0},
          {id: 6, selected: 0, price: 0},
          {id: 7, selected: 0, price: 0}
        ]
      },
      {id: 6,
        plans: []
      },
      {id: 7,
        credences: []
      }
    ],
    user: {
      name: '',
      email: '',
      phone: '',
      address: '',
      city: '',
      zip: '',
      questions: ''
    }
  },
  mutations: {
    subPrice (state, val) {
      state.price -= val
    },
    addPrice (state, val) {
      state.price += val
    },
    applyTva (state, val) {
      state.tva = val
    },
    setDynamicDevis (state, params) {
      state.devis[params.id] = params.set
    },
    setDevis (state, params) {
      var s = Object.keys(params.set)
      for (var i = 0; i < s.length; i++) {
        state.devis[params.id][s[i]] = params.set[s[i]]
      }
    },
    setDevisPrice (state, params) {
      state.devis[params.id].price = params.price
    },
    setDevisMultiplePrice (state, params) {
      for (var i = 0; i < state.devis[params.id][params.subid].length; i++) {
        state.devis[params.id][params.subid][i].price = params.price[i]
      }
    },
    setDevisInfo (state, params) {
      state.devis[params.id][params.subid] = params.val
    },
    setBeautifulPrice (state, price) {
      state.beautifulPrice = price
    },
    setDevisMultipleInfo (state, params) {
      for (var i = 0; i < state.devis[params.id][params.subid].length; i++) {
        state.devis[params.id][params.subid][i].name = params.val[i]
      }
    },
    setPDFLink (state, pdfLink) {
      state.pdfLink = pdfLink
    },
    setUserInfos (state, params) {
      state.user[params.id] = params.value
    },
    setBeautifulTvaTtc (state) {
      state.beautifulTva = parseFloat(state.price * state.tva / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      state.beautifulPriceTTC = parseFloat(state.price + (state.price * state.tva / 100)).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js